export default class ImmunizationTarget {
    public impfungindikation_code: string | null = null;
    public displayname: string | null = null;
    public gruppe: string | null = null;
    public ordernumber: number | null = null;
    public version_id: string | null = null;

    constructor(data?: Partial<ImmunizationTarget>) {
        Object.assign(this, data);
    }
}
